module.exports = __webpack_public_path__ + "static/media/tv.e8c37491.svg";